<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface FormKitCustomGdprProps {
    data: FieldData
}

const props = defineProps<FormKitCustomGdprProps>()
const config = useRuntimeConfig()
</script>
<template>
  <FormKit
    type="checkbox"
    :name="props.data.name"
    :label="props.data.label"
    :validation="props.data.validations"
    :validation-messages="{
      accepted: props.data.validation_messages?.['accepted'] || $t('Pre pokračovanie je potrebné zaškrtnúť.'),
    }"
    :help="props.data.help"
  >
    <template #label>
      <div class="formkit-label">
        {{ $t('Oboznámil som sa s') }}
        <VNuxtLink
          :to="config.public.links.gdpr"
          target="_blank"
        >
          {{ $t('Informáciami o spracúvaní osobných údajov') }}
        </VNuxtLink>
        *
      </div>
    </template>
  </FormKit>
</template>
